import { render } from "./SplashScreen.vue?vue&type=template&id=70ec10b8&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=70ec10b8&scoped=true&lang=css"
import "./SplashScreen.vue?vue&type=style&index=1&id=70ec10b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ec10b8"]])

export default __exports__